import store from '@appStore/store'
import { Tag } from 'api/api-rtk'

import { api } from './api'

export const refetch = () =>
	store.dispatch(api.util.invalidateTags([Tag.Imports]))
